<nz-modal
  [nzWidth]="'800px'"
  [(nzVisible)]="isNewEditVisible"
  (nzVisibleChange)="onIsNewEditVisibleChange($event)"
  [nzTitle]="selectedItem ? 'Edit Tag' : 'Add New Tag'"
  (nzOnCancel)="onCancelClick()"
  [nzOkText]="null"
  [nzCancelText]="null"
>
  <ng-container *nzModalContent>
    <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
      <nz-form-item>
        <nz-form-label nzRequired nzFor="title">Title</nz-form-label>
        <nz-form-control nzErrorTip="Title required.">
          <div class="horizontal">
            <input nz-input formControlName="title" id="title" [placeholder]="'Your title'" />
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="type">Type</nz-form-label>
        <nz-form-control nzErrorTip="Type required.">
          <nz-select formControlName="type" id="type">
            @for (item of getTagTypeList(); track $index) {
              <nz-option [nzValue]="item" [nzLabel]="item"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="color">Color</nz-form-label>
        <nz-form-control nzErrorTip="Color required.">
          <app-color-selector-x formControlName="color" [color]="AppColor.orange"></app-color-selector-x>
        </nz-form-control>
      </nz-form-item>

      <!-- @if (tagType() === TagType.personality) {
        <nz-form-item>
          <nz-form-label nzFor="personality">Personality</nz-form-label>
          <nz-form-control nzErrorTip="Personality required.">
            <textarea
              nz-input
              formControlName="description"
              rows="5"
              id="description"
              [placeholder]="'The personality will be used into the customer '"
            ></textarea>
          </nz-form-control>
        </nz-form-item>
      } -->

      <nz-form-item>
        <nz-form-control>
          <button nz-button [nzType]="'primary'" class="submit-button">{{ selectedItem ? 'Save' : 'Create' }}</button>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>
